import { render, staticRenderFns } from "./CreateCost.vue?vue&type=template&id=2a4a32de&scoped=true"
import script from "./CreateCost.vue?vue&type=script&lang=js"
export * from "./CreateCost.vue?vue&type=script&lang=js"
import style0 from "./CreateCost.vue?vue&type=style&index=0&id=2a4a32de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a32de",
  null
  
)

export default component.exports